<template>
  <div class="products">
    <Banner :banner="banner" />
    <div class="container w1320">
      <div class="title">
        <div class="cn">产品中心</div>
        <div class="en">Product Center</div>
      </div>
      <div class="back">
        <div class="btn" @click="$router.go(-1)">BACK</div>
      </div>
      <div class="list">
        <div class="item" v-for="item in products" :key="item.ID">
          <a :href="item.LINK" target="_blank">
            <img :src="`http://boyang.sansg.com/upload/${item.SMALLPIC}`" alt="" class="img">
            <div class="product-listed__hover">
              <div class="meta">
                <div class="icon el-icon-plus"></div>
                <div class="title">{{item.PRONAME}}</div>
                <div class="text" v-html="item.MEMO"></div>
                <div class="icon el-icon-shopping-cart-2"></div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="more">
        <div class="btn" @click="getProduct">MORE</div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
export default {
  components: {
    Banner
  },
  data(){
    return{
      banner:{
        title:'产品中心',
        img:'/images/productsbanner.jpg'
      },
      products:[],
      page:1
    }
  },
  created(){
    this.getdata()
  },
  watch:{
    $route:'getdata'
  },
  methods: {
    getdata(){
      this.page=1
      this.products=[]
      this.getProduct()
    },
    getProduct(){
      this.$$axios.get('/php/products.php', {
        params: {
          tid: this.$route.params.tid,
          num:6,
          page:this.page
        }
      })
      .then(res=>{
        this.products=this.products.concat(res.data.proarr)
        this.page++
      })
      .catch(error=>{
        console.log(error);
      });
    },
    goto(){

    }
  }
}
</script>

<style scoped>
.products{
  overflow: hidden;
}
.products .container>.title{
  text-align: center;
  padding: 45px 0;
}
.products .container>.title .cn{
  font-family: '宋体';
  font-size: 30px;
  color: #5e7987;
  margin-bottom: 10px;
}
.products .container>.title .en{
  font-family: 'Embassy BT';
  font-size: 20px;
  color: #636363;
}
.products .back{
  display: flex;
  justify-content: flex-end;
  padding: 50px 0;
}
.products .btn{
  position: relative;
  border: 1px solid #5e7987;
  text-align: center;
  display: block;
  width: 180px;
  max-width: 100%;
  font-size: 14px;
  font-family: 'Century751';
  padding: 20px 0;
  cursor: pointer;
  transition: 1s;
}
.products .btn:hover{
  background-color: #5e7987;
  color: #fff;
}
.products .list{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -6px;
}
.products .list .item{
  width: 33.33%;
  padding: 0 6px;
  margin-bottom: 24px;
}
.products .list .item a{
  display: block;
  position: relative;
  cursor: pointer;
}
.products .list .item img.img{
  display: block;
  width: 100%;
}
.products .list .item .product-listed__hover{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  transition: 1s;
}
.products .list .item:hover .product-listed__hover{
  visibility: visible;
  opacity: 1;
}
.products .list .item .product-listed__hover .meta{
  transform: translateY(20px);
  transition: 1s;
  text-align: center;
}
.products .list .item:hover .product-listed__hover .meta{
  transform: translateY(0);
}
.products .list .item .product-listed__hover .meta .title{
  font-size: 16px;
  font-weight: lighter;
}
.products .list .item .product-listed__hover .meta .text{
  font-size: 12px;
  font-weight: lighter;
  margin-top: 10px;
}
.products .list .item .product-listed__hover .meta .icon{
  font-size: 36px;
  margin: 30px 0;
}
.products .more{
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
@media(max-width: 768px){
  .products .back{
    justify-content: center;
  }
  .products .list .item{
    width: 100%;
  }
}
</style>


